export default __webpack_public_path__ + "0b32debd28710fec1a46107f34695fec.png";